module.exports = require("./gv.d.ts");